<template>
    <flex-element class="f-inline-flex">
        <input
            type="checkbox"
            :name="inputNameNew"
            :checked="isChecked"
            :required="renderRequired"
            :aria-label="ariaLabelNew"
            :aria-labelledby="ariaLabelledByNew"
            :element-type="elementType"
            value="true"
            @input="onInput"
            @invalid="onInvalidInput"
        >
    </flex-element>
</template>

<script>
import baseAtom from '@/mixins/base-atom/base-atom-smart';
import { ACheckbox } from '@/data/data-models';

const CHECKED_ATTR_NAME = 'checked-by-default';

export default {
    name: 'a-checkbox',
    mixins: [baseAtom],

    props: {
        displayName: {
            type: String,
            default: 'Checkbox',
        },

        inputName: {
            type: String,
            default: '',
        },

        required: {
            type: Boolean,
            default: false,
        },

        requiredDefault: {
            type: Boolean,
            default: false,
        },

        validationMessage: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            cssDisplay: 'inline-flex',
            inputNameNew: '',
            requiredNew: '',
            validationMessageNew: '',
        };
    },

    computed: {
        isChecked() {
            return this.getElementData(CHECKED_ATTR_NAME);
        },

        updatedElement() {
            return new ACheckbox({
                ...this.updatedBaseElement,
                inputName: this.inputNameNew,
                required: this.requiredNew,
                validationMessage: this.validationMessageNew,
            });
        },

        renderRequired() {
            return this.requiredNew || this.requiredDefault;
        },
    },

    methods: {
        setFieldValues() {
            this.inputNameNew = this.inputName;
            this.requiredNew = this.required;
            this.validationMessageNew = this.validationMessage;
        },

        onInput(e) {
            e.target.setCustomValidity('');
        },

        onInvalidInput(e) {
            e.target.setCustomValidity(this.validationMessageNew);
        },
    },
};
</script>
